import makeFAIcon from "utils/makeFAIcon";

import { faShoppingCart, faLaptop, faLock } from "@fortawesome/free-solid-svg-icons";

export const ShoppingCartIcon = makeFAIcon(faShoppingCart);
export const LaptopIcon = makeFAIcon(faLaptop);
export const LockIcon = makeFAIcon(faLock);
